<style scoped>
.br-10 {
  padding: 10px;
  border-radius: 10px;
}
</style>

<template>
  <v-container fluid>
    <v-row justify="center" align="center">
      <v-col xs="12" sm="10" md="8" lg="8" xl="7">
          <v-form ref="form" @submit.prevent="submitForm($event)">
            <v-card class="br-10 text-center elevation-3">
              <span class="title primary--text text--darken-2"><strong>{{ $t('ticket_form') }}</strong></span>
              <v-select prepend-icon="fa-ticket fa-lg" name="ticket_type" v-model="data.ticket_type" :label="$t('ticket_type')" :items="ticketTypes" :item-text="opt => opt.name" :item-value="opt => opt" :rules="[rules.required]" @input="changeTitle"></v-select>
              <v-text-field prepend-icon="fa-envelope fa-lg" name="title" v-model="data.title" :label="$t('title')" required type="text" :rules="[validateRequired('title')]" :disabled="loading" :readonly="loading"></v-text-field>
              <v-row wrap align="center" justify="center" class="text-center" v-if="data.ticket_type && data.ticket_type.code === 'UDCT'">
                <v-col :md="this.$route.query.ass_acc_no !== undefined ? 12 : 10" sm="12" cols="12">
                  <v-text-field prepend-icon="fa-home fa-lg" name="assessment_no" v-model="assessment_no" :label="$t('assessment_no')" required type="text" :rules="[validateRequired('assessment_no')]" :disabled="loading" :readonly="loading" />
                </v-col>
                <v-col md="2" sm="12" cols="12" v-if="!this.$route.query.ass_acc_no">
                  <v-btn color="green" class="white--text" @click="assessmentVerify(assessment_no)">{{$t('verify') }}</v-btn>
                </v-col>
              </v-row>

              <v-textarea prepend-icon="fa-file fa-lg" :label="$t('content')" v-model="data.body" name="body" type="text" required :rules="[validateRequired('content')]" :disabled="loading" :readonly="loading"></v-textarea><br>
              <span v-if="data.ticket_type && data.ticket_type.code === 'UDCT' && verified === true" class="title primary--text text--darken-2" ><strong>{{ $t('page_assessment.owner_info') }}<br v-if="$vuetify.breakpoint.xsOnly" /></strong></span><br>
              <v-row v-if="data.ticket_type && data.ticket_type.code === 'UDCT' && verified === true" wrap >
                  <v-col cols="12">
                    <div v-if="assessment" class="d-flex justify-center ">
                      <v-col cols="10">
                      <div  class="text-left pa-4" style="border: 1px solid black;">
                        {{ $t('assessment_no') }}:  {{ assessment.assessment_no }}<br />
                        {{ $t('title_no') }}:  {{ assessment.current_title }}<br />
                        {{ $t('lot') }}: {{ assessment.lot || '-' }}<br />
                        {{ $t('locality') }}: {{ assessment.locality }}<br />
                        {{ $t('paid_until') }}: {{ assessment.paid_until }}<br />
                        {{ $t('owner_name') }}: {{ hideText(assessment.name) }}<br />
                        {{ $t('ic_no') + " / " + $t('register_no') }}: {{ hideIC(assessment.icno_nocompany) }}<br />
                      </div>
                    </v-col>
                    </div>
                  </v-col>

              </v-row>
              <br>
              <span v-if="data.ticket_type && data.ticket_type.code === 'UDCT' && verified === true" class="title primary--text text--darken-2" ><strong>{{ $t('exchange_details') }}<br v-if="$vuetify.breakpoint.xsOnly" /></strong></span><br><br>
              <v-row v-if="data.ticket_type && data.ticket_type.code === 'UDCT' && verified === true" wrap  >

                <div style="width:100%" v-if="verified">
                    <v-col cols="12" class="d-flex justify-center">
                      <v-text-field prepend-icon="fa-calendar fa-lg" name="exchange_date" v-model="exchangeDate" :label="$t('exchange_date')" required :rules="[validateRequired('exchange_date')]" type="date"></v-text-field>
                    </v-col>
                    <v-col cols="12" class="d-flex justify-center">
                      <v-simple-table class="mt-05 my-table" style="width: 90%; border: 1px solid #ccc;">
                        <template v-slot:default>
                          <thead >
                            <tr>
                              <th style="border-right: 1px solid #ccc;">{{ $t(`field_index`) }}</th>
                              <th style="border-right: 1px solid #ccc;">{{ $t(`field_actions`) }}</th>
                              <th style="border-right: 1px solid #ccc; width:14%">{{ $t(`field_name`) }}</th>
                              <th style="border-right: 1px solid #ccc;width:14%">{{ $t(`field_identity_no`) }}</th>
                              <th style="border-right: 1px solid #ccc;width:14%">{{ $t(`email_address`) }}</th>
                              <th style="border-right: 1px solid #ccc;">{{ $t(`phone_no`) }}</th>
                              <th style="border-right: 1px solid #ccc;width:18%">{{ $t(`field_address`) }}</th>
                              <th>{{ $t(`field_share`) }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item, index) in owner_data.ownership" :key="index">
                              <td style="border-right: 1px solid #ccc;">{{ index + 1 }}</td>
                              <td style="border-right: 1px solid #ccc;">
                                <v-btn icon color="primary" :disabled="loading" @click="showForm = true;setOwnership(item);setEditOwnershipIndex(index);">
                                  <v-icon>fa-pencil</v-icon>
                                </v-btn>
                                <v-btn icon color="error" :disabled="loading" @click="removeOwnership(item)">
                                  <v-icon>fa-trash</v-icon>
                                </v-btn>
                              </td>
                              <td class="text-weight-medium"
                                  v-for="key in Object.keys(ownership)"
                                  :key="key"
                                  :style="String(key) !== 'share' ? 'border-right: 1px solid #ccc;' : 'border-right: none'">
                                  <span>{{ item[key] }}</span>
                              </td>
                            </tr>
                            <tr v-if="!owner_data.ownership.length">
                              <td colspan="8">
                                Please Add New Owner Details
                              </td>
                            </tr>
                            <tr>
                              <td colspan="8">
                                <v-btn
                                  color="primary"
                                  @click="showForm = true"
                                  tonal
                                  block
                                >
                                  <v-icon>fa-plus</v-icon>
                                </v-btn>
                            </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                    <v-col cols="12" class="d-flex justify-center">
                      <div
                        class="pa-4"
                        style="border: 1px dashed grey; width:90%"
                        v-if="showForm"
                      >
                      <v-form ref="ownerForm" class="mx-03">
                        <v-checkbox
                          :label="$t('company_organization')"
                          v-model="isCompany">
                        </v-checkbox>
                        <v-text-field
                          ref="1-name"
                          type="text"
                          :disabled="loading"
                          :label="$t('field_name')"
                          :rules="[validateRequired('field_name')]"
                          :readonly="loading"
                          :value="ownership.name"
                          @input="setOwnership({ name: $event })"
                        ></v-text-field>

                        <div class="row">
                          <div class="col">
                              <v-text-field
                                v-if="!isCompany"
                                ref="1-identity_no"
                                class="pt-2"
                                clearable
                                name="ic_num"
                                :value="icFormat(ownership.identity_no)"
                                @input="ownership.identity_no = $event"
                                :counter="14"
                                maxLength="14"
                                :label="$t('ic_num')"
                                required type="text"
                                :disabled="loading"
                                :readonly="loading"
                                :rules="[validateRequired('ic_num'), rules.nricLength, rules.dateOfBirth]"
                                >
                              </v-text-field>
                              <v-text-field
                                v-if="isCompany"
                                ref="1-identity_no"
                                class="pt-2"
                                clearable
                                name="ic_num"
                                :value="ownership.identity_no"
                                @input="ownership.identity_no = $event"
                                :label="$t('register_no')"
                                required type="text"
                                :disabled="loading"
                                :readonly="loading"
                                :rules="[validateRequired('register_no')]"
                                >
                              </v-text-field>
                            </div>
                            <div class="col">
                              <v-text-field
                                ref="1-share"
                                type="number"
                                :disabled="loading"
                                :label="$t('field_share')"
                                :rules="[
                                  validateRequired('field_share'),
                                  validateMinShare('field_share'),
                                  validateMaxShare('field_share')
                                ]"
                                :readonly="loading"
                                :value="ownership.share"
                                @input="setOwnership({ share: Number($event) })"
                              ></v-text-field>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col">
                              <v-text-field
                                ref="1-mail_address"
                                type="email"
                                :disabled="loading"
                                :label="$t('email_address')"
                                :rules="[validateRequired('email_address'), rules.email]"
                                :readonly="loading"
                                :value="ownership.mail_address"
                                @input="setOwnership({ mail_address: $event })"
                              ></v-text-field>
                            </div>
                            <div class="col">
                              <v-text-field
                                ref="1-phone_no"
                                type="text"
                                :disabled="loading"
                                :label="$t('phone_no')"
                                :rules="[validateRequired('phone_no')]"
                                :readonly="loading"
                                :value="ownership.phone_no"
                                @input="setOwnership({ phone_no: $event })"
                              ></v-text-field>
                            </div>
                          </div>
                          <v-textarea
                            ref="1-address"
                            :disabled="loading"
                            :label="$t('field_address')"
                            :readonly="loading"
                            :value="ownership.address"
                            @input="setOwnership({ address: $event })"
                          ></v-textarea>

                          <v-btn
                            :disabled="loading"
                            @click="addOwner"
                            color="primary"
                            class="mt-5 mb-2 full-width"
                            block
                          > {{  editOwnershipIndex !== null
                                ? $t('update_ownership')
                                : $t('add_ownership')
                            }}</v-btn>
                          <v-btn
                            :disabled="loading"
                            @click="
                              resetEditOwnershipIndex(editOwnershipIndex);
                              resetOwnerForm();
                              showForm = false;
                            "
                            color="primary"
                            class="mt-5 mb-2"
                            block

                          > {{  $t('cancel') }}</v-btn>
                        </v-form>
                      </div>
                    </v-col>
                    <br />
                  </div>
              </v-row>
              <br>
              <span v-if="data.ticket_type && data.ticket_type.required_attachments" class="title primary--text text--darken-2" :style="data.ticket_type.code === 'UDCT' && verified !== true ? 'display:none' : 'display:inline'"><strong>{{ $t('supporting_documents') }}<br v-if="$vuetify.breakpoint.xsOnly" /> ({{ $t("for_verification_purpose") }})</strong></span>
              <v-row v-if="data.ticket_type && data.ticket_type.required_attachments" wrap :style="data.ticket_type.code === 'UDCT' && verified !== true ? 'display:none' : 'display:inline'">
                <v-col cols="12">
                  <v-file-input :rules="[rules.required, rules.fileSizeLimit]" :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept=".pdf" name="photocopy_ic" type="file" v-model="photocopy_ic" :label="$t('photocopy_ic')" @change="handleFileUpload($event, 'photocopy_ic')" :clearable="false" @click:clear="photocopy_ic = data._attachments.photocopy_ic = null;" capture />
                  <!-- <span v-if="isCordova">{{ $t('photocopy_ic') }} :</span><br />
                  <v-btn color="primary" @click="startCamera('photocopy_ic')" v-if="isCordova && !photocopy_ic">
                    <v-icon class="mr-2">fa-paperclip fa-lg</v-icon> {{ $t(`capture`) }}
                  </v-btn>
                  <v-btn color="error" @click="photocopy_ic = data._attachments.photocopy_ic = null;" v-if="isCordova && photocopy_ic">
                    <v-icon class="mr-2">fa-trash fa-lg</v-icon> photocopy_ic.jpg
                  </v-btn> -->
                </v-col>
                <v-col cols="12">
                  <v-file-input v-if="data.ticket_type && data.ticket_type.code === 'UDCT'" :rules="[rules.fileSizeLimit]" :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept=".pdf" name="photocopy_land_grant" type="file" v-model="photocopy_land_grant" :label="$t('photocopy_land_grant')" @change="handleFileUpload($event, 'photocopy_land_grant')" :clearable="false" @click:clear="photocopy_land_grant = data._attachments.photocopy_land_grant = null;" capture />
                  <!-- <span v-if="isCordova">{{ $t('photocopy_land_grant') }} :</span><br />
                  <v-btn color="primary" @click="startCamera('photocopy_land_grant')" v-if="isCordova && !photocopy_land_grant">
                    <v-icon class="mr-2">fa-paperclip fa-lg</v-icon> {{ $t(`capture`) }}
                  </v-btn>
                  <v-btn color="error" @click="photocopy_land_grant = data._attachments.photocopy_land_grant = null;" v-if="isCordova && photocopy_land_grant">
                    <v-icon class="mr-2">fa-trash fa-lg</v-icon> photocopy_geran_tanah.pdf
                  </v-btn> -->
                </v-col>
                <v-col cols="12">
                  <v-file-input v-if="data.ticket_type && data.ticket_type.code === 'UDCT'" :rules="[rules.fileSizeLimit]" :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept=".pdf" name="photocopy_mot" type="file" v-model="photocopy_mot" :label="$t('photocopy_mot')" @change="handleFileUpload($event, 'photocopy_mot')" :clearable="false" @click:clear="photocopy_mot = data._attachments.photocopy_mot = null;" capture />
                  <!-- <span v-if="isCordova">{{ $t('photocopy_mot') }} :</span><br />
                  <v-btn color="primary" @click="startCamera('photocopy_mot')" v-if="isCordova && !photocopy_mot">
                    <v-icon class="mr-2">fa-paperclip fa-lg</v-icon> {{ $t(`capture`) }}
                  </v-btn>
                  <v-btn color="error" @click="photocopy_mot = data._attachments.photocopy_mot = null;" v-if="isCordova && photocopy_mot">
                    <v-icon class="mr-2">fa-trash fa-lg</v-icon> photocopy_mot.pdf
                  </v-btn> -->
                </v-col>
                <v-col cols="12">
                  <v-file-input v-if="data.ticket_type && data.ticket_type.code === 'UDCT'" :rules="[rules.fileSizeLimit]" :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept=".pdf" name="sales_purchase_agreement" type="file" v-model="sales_purchase_agreement" :label="$t('sales_purchase_agreement')" @change="handleFileUpload($event, 'sales_purchase_agreement')" :clearable="false" @click:clear="sales_purchase_agreement = data._attachments.sales_purchase_agreement = null;" capture />
                    <!-- <span v-if="isCordova">{{ $t('sales_purchase_agreement') }} :</span><br />
                    <v-btn color="primary" @click="startCamera('sales_purchase_agreement')" v-if="isCordova && !sales_purchase_agreement">
                      <v-icon class="mr-2">fa-paperclip fa-lg</v-icon> {{ $t(`capture`) }}
                    </v-btn>
                    <v-btn color="error" @click="sales_purchase_agreement = data._attachments.sales_purchase_agreement = null;" v-if="isCordova && sales_purchase_agreement">
                      <v-icon class="mr-2">fa-trash fa-lg</v-icon> sales_purchase_agreement.pdf
                    </v-btn> -->
                </v-col>
                <v-col cols="12">
                  <v-file-input v-if="data.ticket_type && data.ticket_type.code === 'UDCT'" :rules="[rules.required, rules.fileSizeLimit]" :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept=".pdf" name="photocopy_assessment_receipt" type="file" v-model="photocopy_assessment_receipt" :label="$t('photocopy_assessment_receipt')" @change="handleFileUpload($event, 'photocopy_assessment_receipt')" :clearable="false" @click:clear="photocopy_assessment_receipt = data._attachments.photocopy_assessment_receipt = null;" capture />
                    <!-- <span v-if="isCordova">{{ $t('photocopy_assessment_receipt') }} :</span><br />
                    <v-btn color="primary" @click="startCamera('photocopy_assessment_receipt')" v-if="isCordova && !photocopy_assessment_receipt">
                      <v-icon class="mr-2">fa-paperclip fa-lg</v-icon> {{ $t(`capture`) }}
                    </v-btn>
                    <v-btn color="error" @click="photocopy_assessment_receipt = data._attachments.photocopy_assessment_receipt = null;" v-if="isCordova && photocopy_assessment_receipt">
                      <v-icon class="mr-2">fa-trash fa-lg</v-icon> photocopy_assessment_receipt.pdf
                    </v-btn> -->
                </v-col>
                <v-col cols="12">
                  <v-file-input v-if="data.ticket_type && data.ticket_type.code === 'UDCT'" :rules="[rules.fileSizeLimit]" :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept=".pdf" name="photocopy_pa_letter" type="file" v-model="photocopy_pa_letter" :label="$t('photocopy_pa_letter')" @change="handleFileUpload($event, 'photocopy_pa_letter')" :clearable="false" @click:clear="photocopy_pa_letter = data._attachments.photocopy_pa_letter = null;" capture />
                    <!-- <span v-if="isCordova">{{ $t('photocopy_pa_letter') }} :</span><br />
                    <v-btn color="primary" @click="startCamera('photocopy_pa_letter')" v-if="isCordova && !photocopy_pa_letter">
                      <v-icon class="mr-2">fa-paperclip fa-lg</v-icon> {{ $t(`capture`) }}
                    </v-btn>
                    <v-btn color="error" @click="photocopy_pa_letter = data._attachments.photocopy_pa_letter = null;" v-if="isCordova && photocopy_pa_letter">
                      <v-icon class="mr-2">fa-trash fa-lg</v-icon> photocopy_pa_letter.pdf
                    </v-btn> -->
                </v-col>
                <v-col cols="12">
                  <!-- <v-file-input v-if="!isCordova" :rules="[rules.required]" :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept="image/*" name="latest_telephone_bill" type="file" v-model="latest_telephone_bill" :label="$t('latest_telephone_bill')" @change="handleFileUpload($event, 'latest_telephone_bill')" :clearable="false" @click:clear="latest_telephone_bill = data._attachments.latest_telephone_bill = null;" capture /> -->
                  <v-file-input :rules="[rules.fileSizeLimit]" :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept="image/*" name="document_1" type="file" v-model="document_1" :label="`${$t('other_document')} 1`" @change="handleFileUpload($event, 'document_1')" :clearable="false" @click:clear="document_1 = data._attachments.document_1 = null;" capture />
                  <!-- <span v-if="isCordova">{{ $t('other_document') }} 1 :</span><br />
                  <v-btn color="primary" @click="startCamera('document_1')" v-if="isCordova && !document_1">
                    <v-icon class="mr-2">fa-paperclip fa-lg</v-icon> {{ $t(`capture`) }}
                  </v-btn>
                  <v-btn color="error" @click="document_1 = data._attachments.document_1 = null;" v-if="isCordova && document_1">
                    <v-icon class="mr-2">fa-trash fa-lg</v-icon> document_1.jpg
                  </v-btn> -->
                </v-col>
                <v-col cols="12">
                  <!-- <v-file-input v-if="!isCordova" :rules="[rules.required]" :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept="image/*" name="latest_water_electric_bill" type="file" v-model="latest_water_electric_bill" :label="$t('latest_water_electric_bill')" @change="handleFileUpload($event, 'latest_water_electric_bill')" :clearable="false" @click:clear="latest_water_electric_bill = data._attachments.latest_water_electric_bill = null;" capture /> -->
                  <v-file-input  :rules="[rules.fileSizeLimit]" :disabled="loading" prepend-icon="fa-paperclip fa-lg" accept="image/*" name="document_2" type="file" v-model="document_2" :label="`${$t('other_document')} 2`" @change="handleFileUpload($event, 'document_2')" :clearable="false" @click:clear="document_2 = data._attachments.document_2 = null;" capture />
                  <!-- <span v-if="isCordova">{{ $t('other_document') }} 2 :</span><br />
                  <v-btn color="primary" @click="startCamera('document_2')" v-if="isCordova && !document_2">
                    <v-icon class="mr-2">fa-paperclip fa-lg</v-icon> {{ $t(`capture`) }}
                  </v-btn>
                  <v-btn color="error" @click="document_2 = data._attachments.document_2 = null;" v-if="isCordova && document_2">
                    <v-icon class="mr-2">fa-trash fa-lg</v-icon> document_2.jpg
                  </v-btn> -->
                </v-col>
              </v-row>
            </v-card>
            <br>
            <v-card class="br-10 text-center elevation-3">
              <v-layout class="pa-3" column wrap>
                <span class="title primary--text text--darken-2"><strong>{{ $t('contact_detail') }}</strong></span>
                  <v-text-field prepend-icon="fa-user-circle fa-lg" clearable v-model="data.customer_name" :label="$t('full_name')" name="full_name" required type="text" :disabled="loading" :readonly="loading" :rules="[validateRequired('full_name')]"></v-text-field>
                  <v-text-field class="pt-2" prepend-icon="fa-id-card fa-lg" clearable name="ic_num" :value="icFormat(data.customer_ic)" @input="data.customer_ic = $event" :counter="14" maxLength="14" :label="$t('ic_num')" required type="text" :disabled="loading" :readonly="loading" :rules="[validateRequired('ic_num'), rules.nricLength, rules.dateOfBirth]"></v-text-field>
                  <v-row wrap align="center" justify="center" class="text-center">
                    <v-col cols="12" sm="12" md="7" lg="7">
                      <v-text-field class="pt-2" maxLength="11" prepend-icon="fa-phone-square fa-lg" :label="$t('phone_no')" v-model="data.customer_phone" name="phone_no" type="tel" :disabled="verify.result || loading" :readonly="loading || verify.result" required :rules="[validateRequired('phone_no')]"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="5" lg="5">
                      <v-btn color="primary" rounded outlined :disabled="currentTime > 0 || data.customer_phone.length < 10" @click="sendVerification" v-if="!verify.result">
                        {{ sent ? $t(`resend_verification`, { channel: 'SMS' }) : $t('send_verification', { channel: 'SMS' }) }} <span v-if="currentTime > 0">({{ currentTime }} s)</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row wrap align="center" justify="center" v-if="sent">
                    <v-col md="10" sm="12" cols="12">
                      <v-text-field prepend-icon="fa-code fa-lg" validate-on-blur :rules="[rules.required]" v-model="verify.input" :label="$t('verification_code')" name="code" required type="text" :disabled="verify.result"></v-text-field>
                    </v-col>
                    <v-col md="2" sm="12" cols="12">
                      <v-btn color="primary" rounded outlined :disabled="verify.input.length === 0 || verify.result" @click="verifyCode">
                        {{ $t("verify") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-text-field class="pt-2" prepend-icon="fa-envelope fa-lg" v-model="data.customer_email" :label="$t('email_address')" name="email_address" required type="email" :disabled="loading" :readonly="loading" :rules="[validateRequired('email_address')]"></v-text-field>
              </v-layout>
            </v-card>
            <br>
            <v-layout justify-space-between mt-2>
              <h3 style="font-weight: 900;" class="red--text">PEMBAYARAN SEBANYAK RM10.00 AKAN DIKENAKAN </h3>
              <v-btn :block="$vuetify.breakpoint.xsOnly" color="primary" large rounded type="submit" :disabled="loading" :loading="loading">{{ $t('submit') }}</v-btn>
            </v-layout>
          </v-form>
      </v-col>
      <canvas id="imageCanvas" class="d-none" />
    </v-row>
</v-container>
</template>

<script>
import axios from '../../axios'
import configuration from '../../configurations'
import { throttle } from 'lodash'
import { mapActions, mapMutations, mapState } from 'vuex'

const calculateAspectRatioFit = (
  srcWidth,
  srcHeight,
  maxWidth,
  maxHeight
) => {
  var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight)
  var rtnWidth = srcWidth * ratio
  var rtnHeight = srcHeight * ratio

  return { width: rtnWidth, height: rtnHeight }
}

const downscaleImage = file => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader()

    fileReader.onload = event => {
      const arrayBuffer = event.target.result
      const blob = new Blob([arrayBuffer], { type: 'image/jpeg' })
      const objectUrl = URL.createObjectURL(blob)
      let canvas = document.getElementById('imageCanvas')
      let context = canvas.getContext('2d')
      let image = new Image()

      image.src = objectUrl
      image.onload = () => {
        const { width, height } = calculateAspectRatioFit(
          image.width,
          image.height,
          2048,
          1152
        )

        canvas.width = width
        canvas.height = height
        context.drawImage(image, 0, 0, width, height)
        const data = canvas.toDataURL('image/jpeg', 0.95)
        resolve(data)
      }
    }

    fileReader.onerror = () => {
      fileReader.abort()
      reject(fileReader.error)
    }

    fileReader.readAsArrayBuffer(file)
  })
}

const handleFile = file => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader()
    fileReader.onload = event => {
      const data = event.target.result
      resolve(data)
    }
    fileReader.onerror = () => {
      fileReader.abort()
      reject(fileReader.error)
    }
    fileReader.readAsDataURL(file)
  })
}

export default {
  computed: {
    ...mapState({
      owner_data: state => state.ticket.data,
      ownership: state => state.ticket.ownership,
      editOwnershipIndex: state => state.ticket.editOwnershipIndex,
      step: state => state.step,
      error: state => state.error
    }),
    isCordova () {
      return window.hasOwnProperty('cordova')
    },
    selectedIC () {
      return this.data._attachments && this.data._attachments.photocopy_ic && this.data._attachments.photocopy_ic !== null
    },
    selectedDocument1 () {
      return this.data._attachments && this.data._attachments.document_1 && this.data._attachments.document_1 !== null
    },
    selectedDocument2 () {
      return this.data._attachments && this.data._attachments.document_2 && this.data._attachments.document_2 !== null
    },
    rules () {
      return {
        dateOfBirth: value => (value && value.length > 6 ? (((parseInt(value.replace(/[\s-]/g, '').substr(4, 2)) < 32 && parseInt(value.replace(/[\s-]/g, '').substr(4, 2)) > 0) && (parseInt(value.replace(/[\s-]/g, '').substr(2, 2)) < 13 && parseInt(value.replace(/[\s-]/g, '').substr(2, 2)) > 0)) || this.$t('invalidDateOfBirth')) : true),
        required: value => !!value || this.$t('requiredField'),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || this.$t('invalidEmailFormat')
        },
        percentage: value => (Number(value) <= 100 && Number(value) >= 0) || this.$t('invalidPercentage'),
        nricLength: value => (value ? (value.replace(/[\s-]/g, '').length === 12 || this.$t('invalidNRICFormat')) : true),
        fileSizeLimit: value => !value || value.size < 1572864 || 'File size should be less than 1.5 MB!'
      }
    }
  },
  data: () => ({
    data: {
      _id: '',
      _attachments: {},
      body: '',
      customer_name: '',
      customer_ic: '',
      customer_phone: '',
      customer_email: '',
      ticket_type: null,
      status: 'draft',
      title: ''
    },
    assessment_no: null,
    exchangeDate: null,
    new_info: {},
    photocopy_ic: null,
    photocopy_land_grant: null,
    photocopy_assessment_receipt: null,
    photocopy_pa_letter: null,
    photocopy_mot: null,
    sales_purchase_agreement: null,
    latest_telephone_bill: null,
    latest_water_electric_bill: null,
    document_1: null,
    document_2: null,
    loading: false,
    currentTime: 0,
    ticketTypes: [],
    verify: {
      code: null,
      input: '',
      result: false
    },
    verified: false,
    assessment: null,
    sent: false,
    timer: null,
    showForm: false,
    cameraOption: {
      quality: 50,
      destinationType: window.Camera ? Camera.DestinationType.DATA_URL : null,
      encodingType: window.Camera ? Camera.EncodingType.JPEG : null,
      mediaType: window.Camera ? Camera.MediaType.PICTURE : null,
      sourceType: window.Camera ? Camera.PictureSourceType.CAMERA : null,
      allowEdit: false,
      correctOrientation: true
    },
    isCompany: false
  }),
  beforeMount: async function () {
    this.$store.commit('loading/setPageLoading', { loading: false })
    const user = await this.$store.dispatch('auth/session')
    if (user.userCtx.name && user.userCtx.name.length > 0 && !user.userCtx.roles.includes('_admin')) {
      this.verify.result = true
      this.data = Object.assign({}, this.data, { customer_name: user.userCtx.full_name || '', customer_phone: user.userCtx.phone || '', customer_email: user.userCtx.name || '', customer_ic: user.userCtx.ic_num || '' })
    }
    const { data } = await axios({
      url: `${configuration.WORKER}/tickets/find`,
      method: 'POST',
      data: {
        selector: {
          type: 'ticket-type',
          status: 'active',
          _id: { $gt: null }
        },
        use_index: 'indexes/ticket-type'
      }
    })
    this.ticketTypes = data.docs.sort((a, b) => {
      if (a._id < b._id) return -1
      if (a._id > b._id) return 1
      return 0
    })

    this.data.ticket_type = this.$route.query.ticket !== undefined ? Object.assign({}, ...this.ticketTypes.filter((ticket) => ticket.code === this.$route.query.ticket)) : null
    this.data.title = this.$route.query.ticket !== undefined ? this.data.ticket_type.name : null
    this.assessment_no = this.$route.query.ass_acc_no || null
    if (this.$route.query.ass_acc_no !== undefined) {
      this.assessmentVerify(this.$route.query.ass_acc_no)
    }

    navigator.geolocation.getCurrentPosition(function (position) {
      const geolocation = {
        coords: {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          altitude: position.coords.altitude,
          accuracy: position.coords.accuracy,
          altitudeAccuracy: position.coords.altitudeAccuracy,
          heading: position.coords.heading,
          speed: position.coords.speed
        },
        timestamp: position.timestamp
      }
      this.data.geolocation = geolocation
    }.bind(this), (error) => { alert(error.message) }, { enableHighAccuracy: true })
  },
  methods: {
    ...mapActions(['sendSMS']),
    ...mapMutations({
      addOwnership: 'ticket/addOwnership',
      resetOwnership: 'ticket/resetOwnership',
      removeOwnership: 'ticket/removeOwnership',
      setEditOwnershipIndex: 'ticket/setEditOwnershipIndex',
      resetEditOwnershipIndex: 'ticket/resetEditOwnershipIndex',
      setOwnership: 'ticket/setOwnership',
      setData: 'ticket/setData',
      resetData: 'ticket/resetData'
    }),
    countdown () {
      if (this.currentTime > 0) {
        this.currentTime -= 1
        setTimeout(this.countdown, 1000)
      } else {
        this.currentTime = 0
      }
    },
    changeTitle () {
      this.data.title = this.data.ticket_type.name
    },

    payOnline (data) {
      if (!window.hasOwnProperty('cordova')) {
        window.location.href = `${configuration.host.epayment}/#/confirmation?_id=${
          btoa(data.id)
        }&council=mdkgu&payment_type=ticket`
        return
      }
      let ref = cordova.InAppBrowser.open(`${configuration.host.epayment}/#/confirmation?_id=${
        btoa(data.id)
      }&council=mdkgu&payment_type=ticket`, '_self', 'location=no,enableViewportScale=yes,zoom=no')
      let params = ''
      ref.addEventListener('loadstop', function (event) {
        if (event.url.substring(0, 41) === `${configuration.host.epayment}/#/receipt?`) {
          params = event.url.substring(41, event.url.length)
          ref.close()
          this.$router.push('/receipt?' + params)
        }
        if (event.url === `${configuration.host.epayment}/#/index.html#/` || event.url === `${configuration.host.epayment}/#/`) {
          ref.close()
          this.$router.push('/')
        }
      }.bind(this))
    },
    async assessmentVerify (id) {
      this.verified = false
      const assessment = await this.$store.dispatch('tradingForm/searchData', id)
      if (assessment.full_payment !== 0) {
        this.$store.dispatch('snackbar/setSnackBar', {color: 'error', message: 'Sila Menjelaskan Semua Tunggakan Cukai Sebelum Pindahmilik', visible: true})
        this.verified = false
        this.assessment = null
      } else {
        this.$store.dispatch('snackbar/setSnackBar', {color: 'success', message: this.$t('verify_successful'), visible: true})
        this.verified = true
        this.assessment = {
          assessment_no: assessment.assessment_no,
          current_title: assessment.current_title,
          locality: assessment.locality,
          paid_until: assessment.paid_until,
          name: assessment.name,
          icno_nocompany: assessment.icno_nocompany
        }
      }
    },
    sendVerification: throttle(async function () {
      this.currentTime = 180
      this.verify.code = Math.floor(100000 + Math.random() * 900000).toString()
      setTimeout(this.countdown, 1)
      this.sent = true
      // this.verify.input = this.verify.code
      await this.sendSMS({
        contact: this.data.customer_phone.replace(/\s/g, ''),
        message: `Your verification code is ${this.verify.code} for customer support ticket submission. Expires in 3 mins. Date: ${new Date().toLocaleString()}`
      })
    }, 1000),
    verifyCode () {
      if (this.verify.code === this.verify.input) {
        this.verify.result = true
        this.$store.dispatch('snackbar/setSnackBar', {color: 'success', message: this.$t('verify_successful'), visible: true})
        return
      }
      this.verify.result = false
      this.$store.dispatch('snackbar/setSnackBar', {color: 'error', message: this.$t('invalid_code'), visible: true})
    },
    startCamera: throttle(function (field) {
      const onSuccess = imageData => {
        this[field] = this.data._attachments[field] = {
          content_type: 'image/jpeg',
          data: imageData
        }
      }
      const onFail = message => {
        console.error(message) // eslint-disable-line
        this.$store.dispatch('snackbar/setSnackBar', {color: 'error', message, visible: true})
      }
      navigator.camera.getPicture(onSuccess, onFail, this.cameraOption)
    }, 1000),
    async handleFileSelect (files) {
      let data = null
      let isMultiple = Array.isArray(files)

      if (typeof files === 'undefined') {
        return
      }

      try {
        if (isMultiple) {
          data = []
          for (const file of files) {
            if (file instanceof File) {
              if (file.name.split('.').pop() === 'pdf') {
                data.push(await handleFile(file))
              } else {
                data.push(await downscaleImage(file))
              }
            }
          }
        } else {
          if (files instanceof File) {
            if (files.name.split('.').pop() === 'pdf') {
              data = await handleFile(files)
            } else {
              data = await downscaleImage(files)
            }
          }
        }

        return data
      } catch (error) {
        console.log(error)
      }
    },
    async handleFileUpload (file, field) {
      const result = await this.handleFileSelect(file)
      console.log(result)
      if (!result) return
      this.data._attachments[field] = {
        content_type: result.split(';')[0].replace('data:', ''),
        data: result.split(',')[result.split(',').length - 1]
      }
    },
    icFormat (value) {
      if (!value) return ''
      const format = value.replace(/[-\s]/g, '')
      if (format.length > 8) return `${format.substr(0, 6)}-${format.substr(6, 2)}-${format.substr(8)}`
      if (format.length > 6) return `${format.substr(0, 6)}-${format.substr(6, 2)}`
      return format
    },
    hideIC (text) {
      if (!text) return ''
      let hiddenText = ''
      if (text.length !== 0) {
        for (let i = 0; i < text.length; i++) {
          if (i < text.length - 4) {
            hiddenText += '*'
          } else {
            hiddenText += text[i]
          }
        }
      }
      return hiddenText
    },
    hideText (text) {
      if (!text) return ''
      let hiddenText = ''
      for (let i = 0; i < text.length; i++) {
        if (i > 4) {
          hiddenText += '*'
        } else {
          hiddenText += text[i]
        }
      }
      return hiddenText
    },
    validateRequired (translationKey) {
      const message = this.$t('validate_required', {
        field: this.$t(translationKey.toLowerCase())
      })
      return value => !!value || value === 0 || message
    },
    validateArrayMinItem (translationKey) {
      const message = this.$t('validate_required', {
        field: this.$t(translationKey).toLowerCase()
      })
      return value => value.length > 0 || message
    },
    validateEmail (translationKey) {
      const regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
      const message = this.$t('validate_email', {
        field: this.$t(translationKey).toLowerCase()
      })
      return value => {
        if (value === '-') return true
        return value ? value.match(regex) || message : message
      }
    },
    validateMobileNumber (translationKey) {
      const regex = /^\d{1,14}$/
      const message = this.$t('validate_number', {
        field: this.$t(translationKey).toLowerCase()
      })
      return value => {
        if (value === '') return true
        return value ? value.match(regex) || message : message
      }
    },
    validateMinShare (translationKey) {
      const message = this.$t('validate_min_share', {
        field: this.$t(translationKey).toLowerCase()
      })
      return value => value >= 0 || message
    },
    validateMaxShare (translationKey) {
      const message = this.$t('validate_max_share', {
        field: this.$t(translationKey).toLowerCase()
      })
      return value => value <= 100 || message
    },
    async addOwner () {
      const fields = Object.keys(this.$refs).filter(field =>
        field.startsWith(`1-`)
      )
      for (const field of fields) {
        await this.$refs[field].validate()
      }
      if (fields.some(field => this.$refs[field].hasError)) return

      // const checkBill = this.owner_data.ownership.filter(
      //   owner => owner.bill === true
      // );

      // if (this.owner_data.ownership.length > 0) {
      //   if (checkBill.length >= 1 && this.ownership.bill === true) {
      //     this.$q.notify({
      //       color: "negative",
      //       message: this.$t("message_failed_to_save")
      //     });
      //   } else {
      //     await this.addOwnership();
      //   }
      // } else {
      //   if (this.ownership.bill === false) {
      //     this.$q.notify({
      //       color: "negative",
      //       message: this.$t("message_failed_to_save")
      //     });
      //   } else {
      //     await this.addOwnership();
      //   }
      // }
      this.addOwnership()
      this.resetOwnership()
      for (const field of fields) {
        await this.$refs[field].resetValidation()
      }
      this.$refs['1-name'].focus()
      this.showForm = false
    },
    submitForm: throttle(async function ($event) {
      this.loading = true
      const result = this.$refs.form.validate()
      if (!result) {
        this.loading = false
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: this.$t('incomplete_form'),
          visible: true
        })
        return
      }
      if (!this.verify.result) {
        this.loading = false
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: this.$t('phone_is_not_verify'),
          visible: true
        })
        return
      }
      if (this.owner_data.ownership.length === 0) {
        this.loading = false
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: this.$t('incomplete_owner_info'),
          visible: true
        })
        return
      }
      try {
        if (this.data.ticket_type.code === 'UDCT') {
          let ownershipData = []
          ownershipData = [...this.owner_data.ownership]
          for (var i = 0; i < ownershipData.length; i++) {
            if (i === 0) {
              Object.assign(this.owner_data.ownership[0], {
                bill: true
              })
            } else {
              Object.assign(this.owner_data.ownership[i], {
                bill: false
              })
            }
          }
          this.data.new_info = {
            assessment_account_no: this.assessment_no,
            exchangeDate: this.exchangeDate,
            new_owner: [...ownershipData]
          }
        }
        this.data.title = this.data.title.trim().toUpperCase()
        this.data.body = this.data.body.trim().toUpperCase()
        this.data.customer_name = this.data.customer_name.trim().toUpperCase()
        this.data.customer_phone = this.data.customer_phone.replace(/\s/g, '')
        this.data.customer_email = this.data.customer_email.replace(/\s/g, '')
        this.data.channel = `e-Services`
        const response = await axios({
          url: `${configuration.WORKER}/tickets`,
          method: 'POST',
          data: this.data
        })
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'success',
          message: this.$t('submit_successful'),
          visible: true
        })
        this.payOnline(response.data)
        // this.$router.push(`/ticket/detail/${response.data.id}?feedback=true`)
      } catch (error) {
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: error.message || error,
          visible: true
        })
      } finally {
        this.loading = false
      }
    }, 500)
  }
}
</script>
